import { useMemo } from 'react';
import { trpcTenant } from '@duke-hq/app-provider-web/tenant/trpcTenant';
import { DUKE_DOMAIN } from '@duke-hq/shared-constants/emails';

export function useProviderEmailDomains() {
  const { data, isLoading } = trpcTenant.emailDomains.getEmailDomains.useQuery();

  return useMemo(() => {
    const allowedDomains = data?.allowedDomains ?? [DUKE_DOMAIN];
    const defaultDomain = data?.defaultDomain ?? null;

    return {
      allowedDomains,
      defaultDomain,
      isLoading,
    };
  }, [data, isLoading]);
}
